/**
 * Updates main and sticky product price blocks for supply widget.
 * @param {string} sectionId
 * @param {{ price: string, compareAtPrice: string, priceRaw: number, compareAtPriceRaw: number }} priceData
 */
function updateProductPriceBlocks(sectionId, priceData) {
  if (!sectionId || !priceData) {
    return;
  }

  updateProductPriceBlockElement(document.getElementById(`price-${sectionId}`), priceData);
  updateProductPriceBlockElement(
    document.getElementById(`sticky-price-${sectionId}`),
    priceData,
  );
}

function updateProductPriceBlockElement(priceBlock, priceData) {
  if (!priceBlock) {
    return;
  }

  const { price, compareAtPrice, priceRaw, compareAtPriceRaw } = priceData;

  const priceContainer = priceBlock.querySelector(".price");
  if (!priceContainer) {
    return;
  }

  const isOnSale = compareAtPriceRaw > priceRaw;

  priceContainer.classList.toggle("price--on-sale", isOnSale);

  const priceParentContainer = priceContainer.closest(".product__info-container");
  let multiplier = 1;

  if (priceParentContainer) {
    const supplyWidget = priceParentContainer.querySelector('supply-widget');
    const quantityInput = priceParentContainer.querySelector('quantity-counter input[name="quantity"]');
    if (supplyWidget) {
      multiplier = parseInt(supplyWidget.dataset.selectedQuantity, 10) || 1;
    }
    if (quantityInput) {
      multiplier = parseInt(quantityInput.value, 10) || 1;
    }
  }

  const currencyMatch = price.match(/[^\d,.\s]+\s*$/);
  const currency = currencyMatch ? currencyMatch[0].trim() : '';
  const formatPrice = (rawAmount) => {
    const total = (rawAmount * multiplier) / 100;
    return currency ? `${total.toFixed(2).replace('.', ',')} ${currency}` : total.toFixed(2).replace('.', ',');
  };

  const regularPriceEl = priceContainer.querySelector(
    ".price__regular .wt-product__price__final",
  );
  if (regularPriceEl) {
    regularPriceEl.innerHTML = formatPrice(priceRaw);
  }

  const salePriceEl = priceContainer.querySelector(
    ".price__sale .wt-product__price__final",
  );
  if (salePriceEl) {
    salePriceEl.innerHTML = formatPrice(priceRaw);
  }

  const saleDiv = priceContainer.querySelector(".price__sale");
  if (saleDiv) {
    saleDiv.classList.toggle("visible", isOnSale);
    saleDiv.classList.remove("visible-main-product");
  }

  const compareEl = priceContainer.querySelector(".wt-product__price__compare");
  if (compareEl) {
    compareEl.innerHTML = isOnSale ? formatPrice(compareAtPriceRaw) : "";
    compareEl.classList.toggle("hidden", !isOnSale);
  }

  let percentEl = priceContainer.querySelector(".price-item--percent");
  if (isOnSale) {
    const percent = Math.round(
      ((compareAtPriceRaw - priceRaw) / compareAtPriceRaw) * 100,
    );
    if (percentEl) {
      percentEl.textContent = `-${percent}%`;
    } else {
      const wrapper = priceContainer.querySelector(
        ".price__sale__details-wrapper",
      );
      if (wrapper) {
        percentEl = document.createElement("span");
        percentEl.className = "price-item--percent";
        percentEl.textContent = `-${percent}%`;
        wrapper.appendChild(percentEl);
      }
    }
  } else if (percentEl) {
    percentEl.remove();
  }
}

window.updateProductPriceBlocks = updateProductPriceBlocks;
